import Vue from 'vue'
import i18n from 'i18n'

Vue.filter('price', (price100: number): string => {
	return (price100 / 100).toLocaleString(i18n.locale, { style: 'decimal', maximumFractionDigits: 2 })
})

Vue.filter('percent', (p: number): string => {
	return p.toLocaleString(i18n.locale, { style: 'percent', maximumFractionDigits: 2 })
})
